<template>

    <div class="form-group">
        <validation-provider :rules="rules" v-slot="{ errors }" :vid="vid" class="d-block">
            <label :for="id" v-html="name"></label>
            <div class="input-group">

                <div class="input-group-prepend"><span class="input-group-text"><i
                    class="far fa-calendar-alt"></i></span></div>

                <VueCtkDateTimePicker v-model="value"
                                      class="form-control p-0"
                                      :class="{'is-invalid': errors[0]}"
                                      @input="$emit('update:value', value)"
                                      :id="id"
                                      :no-label="true"
                                      formatted="DD.MM.YYYY HH:mm Z"
                                      format="YYYY-MM-DD HH:mm"
                                      output-format="YYYY-MM-DDTHH:mm:ssZ"
                                      :label="trans('Select date and time')"
                                      :button-now-translation="trans('Now')"
                                      locale="ru_RU">
                </VueCtkDateTimePicker>

            </div>
            <div class="text-danger small mt-1">{{ errors[0] }}</div>
        </validation-provider>
    </div>

</template>

<script>
export default {
    name: "form-date-time",
    props: ["name", "value", "rules", "vid"],
    data() {
        return {
            id: this.getRandId("date-")
        };
    }
}
</script>
